var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabtestnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 4.66644V7.48972C7.99992 7.82436 7.91595 8.15365 7.75571 8.44742L5.20997 13.1146C4.66475 14.1142 5.38822 15.3329 6.52681 15.3329H13.4729C14.6115 15.3329 15.335 14.1142 14.7898 13.1146L12.244 8.44742C12.0838 8.15365 11.9998 7.82436 11.9998 7.48972V4.66644",
    stroke: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 4.66644H13.333",
    stroke: "#714FFF",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabtestnew);
export default __webpack_public_path__ + "static/media/labtestnew.ae72c2ae0f29eb3e0c5d3381cd065910.svg";
export { ForwardRef as ReactComponent };